<template>
  <div class="userListDiv">
    <userItem v-for="(user, index) in users" :key="index" :user="user" :custom-params="index"
      :can-delete="canEdit && !user.disableDelete" style="margin-right: 10px" @delete="deleteUser" />
    <addBtn v-if="canEdit" @click="addPerson" />
    <component :is="userSelectDlg" ref="userSelectDlg" :custom-com-params="customComParams" :select-list="users"
      @userSelected="handleUserSelected" />
  </div>
</template>

<script>
import userItem from "./userItem";
import addBtn from "./addBtn";
import personChoose from "@/CommonDP/pages/components/launchFlow/components/personChoose.vue";
import { getUserSelectDlg } from "../flowFormRegister";

export default {
  components: { userItem, addBtn, personChoose },
  model: {
    prop: "users",
    event: "input"
  },
  props: {
    users: {
      type: Array,
      default: () => []
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    // 这些参数会传递给选人组件中，本组件不使用
    customComParams: {
      type: [Object, Array, String, Number, Boolean],
      default: () => undefined
    },
    // 这些参数会传递给选人组件中(作为 show() 方法的参数)，本组件不使用
    userSelectionParams: {
      type: Object,
      default: () => {}
    },
    useCustomUserSelector: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      // 默认使用内部的选人组件
      userSelectDlg: "personChoose"
    };
  },

  methods: {
    addPerson() {
      this.openUserSelectDlg();
    },
    deleteUser(user, index) {
      this.users.splice(index, 1);
    },
    async openUserSelectDlg() {
      let com = "personChoose";
      if (this.useCustomUserSelector) {
        com = getUserSelectDlg();
        if (com) {
          this.userSelectDlg = com;
        }
      }
      await this.$nextTick();
      const title = "选择人员";
      this.$refs.userSelectDlg.show(title, this.userSelectionParams);
    },
    handleUserSelected(list, type, params) {
      const oldSize = this.users.length;
      const addingList = [];
      list.forEach(user => {
        if (user.userId && !this.users.some(item => item.userId === user.userId)) {
          this.users.push(user);
          addingList.push(user);
        }
      });
      if (oldSize !== this.users.length) {
        this.$emit("input", this.users, addingList);
      }
    }
  }
};
</script>

<style>
.userListDiv {
  line-height: 30px;
}
</style>
